var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseLoading',{attrs:{"spinning":_vm.coachLoading,"size":"large"}},[_c('EditForm',{attrs:{"resource":_vm.coach}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }